import { render } from "./event-pusher.vue?vue&type=template&id=65783580"
import script from "./event-pusher.vue?vue&type=script&lang=js"
export * from "./event-pusher.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__